import React, { useEffect, useState } from 'react'
import { useMsal } from '@azure/msal-react';
import Carousel from 'react-bootstrap/Carousel';
import styles from "./Login.module.scss";
import { loginRequest } from '../../environments/environments';
import img1 from "../../assets/images/login/img1.png";
import img2 from "../../assets/images/login/img2.png";
import img3 from "../../assets/images/login/img3.png";
import eyLogo from "../../assets/images/eyLogo.svg";

export default function Login() {
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('');
  const [dates, setDates] = useState('');
  const { instance } = useMsal();


useEffect(() => {
  const interval = setInterval(() => {
    let date = new Date();
    let hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
    setHours(hours > 9 ? "" + hours : "0" + hours);
    let minute = date.getHours() > 9 ? "" + date.getHours() : "0" + date.getHours();
    setMinutes(minute);
    let dd = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
    let day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()];
    let MM = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"][date.getMonth()];
    let dateText = `${day},  ${dd} ${MM} ${date.getFullYear()}`;
    setDates(dateText);
  }, 1000);
  return () => clearInterval(interval);
}, []);


  // const Login = ()=> {
  //     localStorage.removeItem("isLogout")
  //     instance.loginRedirect(loginRequest).then(res=> {
  //     console.log(res);
  //   }).catch(e => {
  //     console.log(e);
  //   });
  // }

  return (

    <div>
      {/* Clock */}
      <div className={styles.clock}>
        <h2 className={styles.clockTime}>{hours}<span className={styles.blink}>:</span>{minutes}</h2>
        <h4 className={styles.clockDate}>{dates}</h4>
      </div>

    <Carousel fade>
      <Carousel.Item>
        <img className="d-block w-100" src={img1} alt="First slide" />
        <Carousel.Caption>
          <img style={{ width: "6rem" }} src={eyLogo} alt="EY" />
          <h3 className="fw-300 mt-4">
            Eyrn has identified over 369 risks since you’ve started using.
          </h3>
          <p>
            The identification of over 369 risks suggests a comprehensive and
            diligent approach to risk management. It implies that a thorough
            analysis was conducted to identify potential threats and
            vulnerabilities that could impact a particular project, initiative,
            or organization. This level of detail in risk identification can
            help ensure that potential risks are not overlooked and that
            appropriate mitigation strategies can be developed to address them.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src={img2} alt="Second slide" />

        <Carousel.Caption>
          <img style={{ width: "6rem" }} src={eyLogo} alt="EY" />
          <h3 className="fw-300 mt-4">
            There are new issues for you to review
          </h3>
          <p>
            Supply chain issues look like they will text of the printing and
            typesetting industry. Lorem Ipsum has been the industry's standard
            dummy text ever since the 1500s, when an unknown printer took a
            galley of type and scrambled it to make a type specimen book
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src={img3} alt="Third slide" />

        <Carousel.Caption>
          <img style={{ width: "6rem" }} src={eyLogo} alt="EY" />
          <h3 className="fw-300 mt-4">
            Read the latest risk report from the World Economic Forum
          </h3>
          <p>
            The report identified the top global risks in terms of likelihood
            and impact, as well as the most interconnected risks, and provided
            insights and recommendations for policymakers, business leaders, and
            individuals to manage and mitigate these risks.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
    </div>
  );
}
